import { Grid, MenuItem } from '@material-ui/core';
import React, { useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import QCXFinalCheckboxField from '../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXFinalForm from '../../shared-components/final-form/QCXFinalForm';
import QCXSelectMoedaAutocomplete from '../../shared-components/final-select-moeda-field/QCXSelectMoedaAutocomplete';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXSelectBancoAutocompleteField from '../../shared-components/select-banco/QCXSelectBancoAutocompleteField';
import QCXSelectContaContabilAutocomplete from '../../shared-components/select-conta-contabil/QCXSelectContaContabilAutocomplete';
import { formatAgencia, formatContaCorrente } from '../../utils/hooks/form/field/formatters';
import { parseAgencia, parseContaCorrente } from '../../utils/hooks/form/field/parsers';
import {
  validateAgencia,
  validateContaCorrente,
  required as requiredValidator,
} from '../../utils/validators/field/validator';
import QCXFinalDateTimePickerField from '../../shared-components/final-date-time-picker-field/QCXFinalDateTimePickerField';
import QCXFinalDatePickerField from '../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import { userHasRole } from '../perfil/perfil-utils';
import QCXFinalTextFieldAlt from '../../shared-components/final-text-field/QCXFinalTextFieldAlt';

export default function QCXContaBancariaForm({
  isConsult,
  isUpdate,
  initialValues,
  handleSubmit,
  onAlterarSaldo,
  handleChangeToConsult,
  handleChangeToUpdate,
  handleCancelUpdate,
  authInfo,
  ...restProps
}) {
  const { t } = useTranslation();
  const handleControlarSaldoChange = useCallback(
    (form) => (value) => {
      if (!value) {
        form.change('moeda', undefined);
        form.change('saldoInicial', undefined);
      }
    },
    []
  );

  const handleTrySaldoInicial = useCallback(
    (form) => (value) => {
      onAlterarSaldo(true);
    },
    [onAlterarSaldo]
  );

  const listenerList = useMemo(
    () => [
      {
        name: 'controlarSaldo',
        fn: handleControlarSaldoChange,
      },
      {
        name: 'saldoInicial',
        fn: handleTrySaldoInicial,
      }
    ],
    [handleControlarSaldoChange, handleTrySaldoInicial]
  );

  return (
    <>
      <QCXFinalForm
        isConsult={isConsult}
        isUpdate={isUpdate}
        initialValues={initialValues}
        handleSubmitValues={handleSubmit}
        handleChangeToUpdate={handleChangeToUpdate}
        handleCancelUpdate={handleCancelUpdate}
        onChangeListeners={listenerList}
        authInfo={authInfo}
        {...restProps}
      >
        {({ values }) => (
          <>
            {(isConsult || isUpdate) && (
              <Grid item xs={12} sm={3} md={2} lg={2}>
                <QCXFinalTextField
                  id="text-field-code"
                  key="text-field-code"
                  name="id"
                  label={t('com.muralis.qcx.codigo')}
                  disabled
                />
              </Grid>
            )}
            <Grid item xs={12} {...(isConsult || isUpdate ? { sm: 9, md: 6, lg: 6 } : { sm: 12, md: 6, lg: 7 })}>
              <QCXFinalTextField
                id="text-field-description"
                key="text-field-description"
                name="description"
                label={t('com.muralis.qcx.descricao')}
                maxLength={30}
                disabled={isConsult}
                validate={requiredValidator}
                required
              />
            </Grid>
            <Grid item xs={12} {...(isConsult || isUpdate ? { sm: 12, md: 4, lg: 4 } : { sm: 12, md: 6, lg: 5 })}>
              <QCXSelectBancoAutocompleteField
                id="autocomplete-select-banco-field"
                key="autocomplete-select-banco-field"
                name="banco.id"
                label={t('com.muralis.qcx.banco.label')}
                initialValues={values}
                fieldProps={{ validate: requiredValidator }}
                disabled={isConsult}
                required
              />
            </Grid>
            <Grid item xs={12} {...(isConsult || isUpdate ? { sm: 6, md: 5, lg: 3 } : { sm: 6, md: 5, lg: 3 })}>
              <QCXFinalTextField
                id="text-field-agencia"
                key="text-field-agencia"
                name="agencia"
                label={t('com.muralis.qcx.banco.agencia')}
                validate={validateAgencia}
                parse={parseAgencia}
                format={formatAgencia}
                formatOnBlur
                maxLength={6}
                disabled={isConsult}
              />
            </Grid>
            <Grid item xs={12} {...(isConsult || isUpdate ? { sm: 6, md: 7, lg: 5 } : { sm: 6, md: 7, lg: 4 })}>
              <QCXFinalTextField
                id="text-field-conta-corrente"
                key="text-field-conta-corrente"
                name="contaCorrente"
                label={t('com.muralis.qcx.banco.contaCorrente')}
                validate={validateContaCorrente}
                // parse={parseContaCorrente}
                // format={formatContaCorrente}
                // formatOnBlur
                maxLength={11}
                disabled={isConsult}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              <QCXSelectContaContabilAutocomplete
                id="select-field-conta-contabil"
                key="select-field-conta-contabil"
                name="planoDeConta.id"
                label={t('com.muralis.qcx.empresa.contaContabil')}
                initialValues={values}
                disabled={isConsult}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
                  <QCXFinalTextFieldAlt
                    name="tipoPix"
                    label="Tipo da Chave Pix"
                    select
                    disabled={isConsult}
                    validate={undefined}
                  >
                    <MenuItem value="CPF">CPF</MenuItem>
                    <MenuItem value="TELEFONE">TELEFONE</MenuItem>
                    <MenuItem value="ALEATORIA">ALEATORIA</MenuItem>
                  </QCXFinalTextFieldAlt>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <QCXFinalTextField
                    id="chave-pix"
                    key="chave-pix"
                    name="chavePix"
                    label='Chave Pix'
                    disabled={isConsult}
                    validate={undefined}
                  />
                </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <QCXFinalCheckboxField
                    id="checkbox-field-controlar-saldo"
                    key="checkbox-field-controlar-saldo"
                    name="controlarSaldo"
                    label={t('com.muralis.qcx.banco.controlarSaldo')}
                    disabled={isConsult}
                  />
                </Grid>
                <Grid item xs={4}>
                  <QCXFinalCheckboxField
                    id="checkbox-field-remove-digito"
                    key="checkbox-field-remove-digito"
                    name="removerDigitoXml"
                    label={t('com.muralis.qcx.banco.removerDigito')}
                    disabled={isConsult}
                  />
                </Grid>
                <Grid item xs={4}>
                  <QCXFinalCheckboxField
                    id="checkbox-field-remove-agencia"
                    key="checkbox-field-remove-agencia"
                    name="removerDigitoAgenciaXml"
                    label={t('com.muralis.qcx.banco.removerDigitoAgencia')}
                    disabled={isConsult}
                  />
                </Grid>
              </Grid>
            </Grid>

            {values?.controlarSaldo && (
              <>
                <Grid item xs={12} {...(isConsult || isUpdate ? { sm: 7, md: 4, lg: 4 } : { sm: 7, md: 4, lg: 5 })}>
                  <QCXSelectMoedaAutocomplete
                    id="autocomplete-select-moeda-field"
                    key="autocomplete-select-moeda-field"
                    name="moeda.id"
                    label={t('com.muralis.qcx.moeda.label')}
                    initialValues={values}
                    fieldProps={{ validate: requiredValidator }}
                    disabled={isConsult || !values?.controlarSaldo}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={5} md={3}>
                  <QCXFinalAlternativeCurrencyField
                    id="numeric-decimal-saldo-inicial-field"
                    key="numeric-decimal-saldo-inicial-field"
                    name="saldoInicial"
                    label={t('com.muralis.qcx.conta.saldoInicial')}
                    scale={2}
                    disabled={
                      ((!values?.controlarSaldo ||
                        Boolean(values?.dataSaldoInicial)) && !userHasRole(authInfo, 'saldo-inicial-alterar')) || isConsult
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <QCXFinalDatePickerField
                    id="data-saldo-inicial"
                    key="data-saldo-inicial"
                    name="refSaldoInicial"
                    label='Data de referência do saldo inicial'
                    disableFuture
                    disabled={
                      isConsult ||
                      (Boolean(values?.dataSaldoInicial) && !userHasRole(authInfo, 'saldo-inicial-alterar'))
                    }
                    validate={undefined}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <QCXFinalDateTimePickerField
                    id="data-saldo-inicial"
                    key="data-saldo-inicial"
                    name="dataSaldoInicial"
                    label='Momento de registro do saldo inicial'
                    disableFuture
                    disabled
                    validate={undefined}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <QCXFinalTextField
                    id="usuario-saldo-inicial"
                    key="usuario-saldo-inicial"
                    name="usuarioSaldoInicial"
                    label='Usuário que registrou o saldo inicial'
                    disabled
                    validate={undefined}
                  />
                </Grid>
              </>
            )}
          </>
        )}
      </QCXFinalForm>
    </>
  );
}
